import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Tailwind 클래스 충돌 해결 + 조건부 클래스 합성 유틸리티
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// 날짜 포맷 (date-fns 없이 간단 포맷)
export function formatDate(date: Date | string, locale = 'ko-KR'): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' })
}

// 날짜 + 시간 (admin/activity 등 분 단위 시간 필요한 화면용)
export function formatDateTime(date: Date | string, locale = 'ko-KR'): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleString(locale, {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
    hour12: false,
  })
}

// 숫자 포맷 (천 단위 구분)
export function formatNumber(n: number, locale = 'ko-KR'): string {
  return new Intl.NumberFormat(locale).format(n)
}

// 파일 크기 포맷
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

// URL 쿼리스트링 파싱
export function parseQueryString(search: string): Record<string, string> {
  return Object.fromEntries(new URLSearchParams(search))
}

/** 로컬(KST) 달력 기준 YYYY-MM-DD — toISOString() 은 UTC 라 00~09시에 어제 날짜가 된다. */
export function todayLocalISO(): string {
  return new Date().toLocaleDateString('en-CA')  // en-CA = YYYY-MM-DD
}
